/* TJD — stone swatches on product cards.
   Clicking a gem dot swaps the card image to that stone's variant image and
   repoints the card's link at that variant. Host cards mark themselves with
   `data-tjd-stone-card` and tag swappable images with `data-tjd-stone-img`. */
(function () {
  'use strict';

  var CARD_SELECTOR = '[data-tjd-stone-card], .product-item';

  function closestCard(el) {
    return el.closest ? el.closest(CARD_SELECTOR) : null;
  }

  function cardImages(card) {
    var tagged = card.querySelectorAll('[data-tjd-stone-img]');
    if (tagged.length) return tagged;
    return card.querySelectorAll('.product-item__media img.image__img');
  }

  function applyStone(card, button) {
    var src = button.getAttribute('data-image-src');
    var srcset = button.getAttribute('data-image-srcset');
    var alt = button.getAttribute('data-image-alt');
    var url = button.getAttribute('data-variant-url');
    var variantId = button.getAttribute('data-variant-id');

    if (src) {
      // Both the resting and the hover image become this stone, so hovering
      // can't reveal a photo of a stone the shopper didn't pick.
      Array.prototype.forEach.call(cardImages(card), function (img) {
        if (srcset) {
          img.setAttribute('srcset', srcset);
        } else if (img.hasAttribute('srcset')) {
          img.removeAttribute('srcset');
        }
        img.setAttribute('src', src);
        if (alt && img.getAttribute('aria-hidden') !== 'true') {
          img.setAttribute('alt', alt);
        }
      });
    }

    if (url) {
      var links = card.querySelectorAll(
        'a[data-tjd-stone-link], .product-item__image-link, .product-item__product-title a'
      );
      Array.prototype.forEach.call(links, function (link) {
        link.setAttribute('href', url);
      });

      Array.prototype.forEach.call(card.querySelectorAll('[data-product-url]'), function (el) {
        el.setAttribute('data-product-url', url);
      });
    }

    if (variantId) {
      var input = card.querySelector('.product-item__product-form-variant-input');
      if (input) input.value = variantId;

      Array.prototype.forEach.call(
        card.querySelectorAll('[data-quick-shop-trigger][data-product-id]'),
        function (el) {
          el.setAttribute('data-product-id', variantId);
        }
      );
    }

    Array.prototype.forEach.call(card.querySelectorAll('[data-tjd-stone]'), function (el) {
      el.setAttribute('aria-pressed', el === button ? 'true' : 'false');
    });

    setLabel(card, button.getAttribute('data-stone-name'));
  }

  function setLabel(card, text) {
    var label = card.querySelector('[data-tjd-stone-label]');
    if (!label) return;
    label.textContent = text || label.getAttribute('data-default-label') || '';
  }

  function resetLabel(card) {
    var selected = card.querySelector('[data-tjd-stone][aria-pressed="true"]');
    setLabel(card, selected ? selected.getAttribute('data-stone-name') : null);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-tjd-stone]') : null;
    if (!button) return;

    var card = closestCard(button);
    if (!card) return;

    // The whole card is a link in some grids — never let the dot navigate.
    event.preventDefault();
    event.stopPropagation();
    applyStone(card, button);
  });

  // Hovering a dot names the stone without committing the swap.
  document.addEventListener(
    'mouseover',
    function (event) {
      var button = event.target.closest ? event.target.closest('[data-tjd-stone]') : null;
      if (!button) return;

      var card = closestCard(button);
      if (card) setLabel(card, button.getAttribute('data-stone-name'));
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var button = event.target.closest ? event.target.closest('[data-tjd-stone]') : null;
      if (!button) return;

      var card = closestCard(button);
      if (card) resetLabel(card);
    },
    true
  );
})();
